import { Table } from 'antd';

const TablaEstadoCuenta = ({ loading, estadoCuenta }) => {

    const numberFormat = new Intl.NumberFormat('es-MX', {minimumFractionDigits: 2});

    // Calcular saldo acumulado
    const calculateRunningBalance = (index) => {
        let balance = 0;
        for (let i = 0; i <= index; i++) {
            const abono = parseFloat(estadoCuenta[i]?.abono || 0);
            const retiro = parseFloat(estadoCuenta[i]?.retiro || 0);
            balance += (abono - retiro);
        }
        return balance;
    };

    const columns = [
        {
            title: 'OBRA',
            dataIndex: 'nombre_obra',
            key: 'nombre_obra'
        },
        {
            title: 'FECHA',
            dataIndex: 'fecha_creacion',
            key: 'fecha_creacion',
            render: (f_) => f_ ? new Date(f_).toLocaleDateString("es-Mx") : '-'
        },
        {
            title: 'CONTRATISTA',
            dataIndex: 'nombre_contratista',
            key: 'nombre_contratista',
        },
        {
            title: 'PARTIDA',
            dataIndex: 'partida',
            key: 'partida',
            render: (text) => text || '-'
        },
        {
            title: 'TIPO DE PAGO',
            dataIndex: 'tipo_de_pago',
            key: 'tipo_de_pago',
            render: (text) => text || '-'
        },
        {
            title: 'RETIRO',
            dataIndex: 'retiro',
            key: 'retiro',
            render: (text) => `$ ${numberFormat.format(parseFloat(text || 0))}`,
        },
        {
            title: 'DEPÓSITOS',
            dataIndex: 'abono',
            key: 'abono',
            render: (text) => `$ ${numberFormat.format(parseFloat(text || 0))}`,
        },
        {
            title: 'SALDO',
            dataIndex: 'saldo',
            key: 'saldo',
            render: (_, record, index) => {
                const balance = calculateRunningBalance(index);
                return `$ ${numberFormat.format(balance)}`;
            },
        },
        {
            title: 'RELACIÓN',
            dataIndex: 'numero_relacion',
            key: 'numero_relacion',
        },
        {
            title: 'OBSERVACIONES',
            dataIndex: 'observaciones',
            key: 'observaciones',
            render: (text) => text || '-',
            ellipsis: true,
        },
    ];

    return (
        <>
            <Table 
                dataSource={estadoCuenta} 
                columns={columns}
                rowKey={record => record.id}
                loading={loading} 
            />
        </>
    )
}

export default TablaEstadoCuenta;